module.exports = __webpack_public_path__ + "static/media/KP.69b9a975.svg";